
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import WhatsAppButton from './components/feature/WhatsAppButton';
import ScrollToTopButton from './components/feature/ScrollToTopButton';
import StructuredData from './components/feature/StructuredData';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <StructuredData />
      <Header />
      <main>
        <AppRoutes />
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </BrowserRouter>
  );
}

export default App;
